module.exports = __webpack_public_path__ + "static/media/storeMasterActive.54cf4c84.svg";